module.exports = __webpack_public_path__ + "img/printer.a664f9a1.svg";